module.exports = __webpack_public_path__ + "img/xyftLogo.b353d47f.png";